import { createAction, props } from '@ngrx/store';

export const loadDownloadFactSheets = createAction('[DownloadFactSheets] Load DownloadFactSheets', props<{ name: string }>());

export const loadDownloadFactSheetsSuccess = createAction(
  '[DownloadFactSheets] Load DownloadFactSheets Success',
  props<{ response: any }>()
);

export const loadDownloadFactSheetsFailure = createAction(
  '[DownloadFactSheets] Load DownloadFactSheets Failure',
  props<{ error: Error | any }>()
);
